import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { TooltipPosition } from '@angular/material/tooltip';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-context-submenu',
  templateUrl: './context-submenu.component.html'
})
export class ContextSubmenuComponent {
  @Input() items: MenuItem[] = [];

  @Output() closed = new EventEmitter<void>();
  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;

  run(item: MenuItem): void {
    if (item.disabled) return;
    item.command?.({ item, originalEvent: undefined });
  }

  // Po odsianiu ukrytych pozycji zostają tylko separatory, które mają co oddzielać z obu stron - inaczej
  // kreska z końca albo początku listy rysuje podział, który niczego nie rozdziela.
  visible(list: MenuItem[] | undefined): MenuItem[] {
    const items = (list ?? []).filter(i => i.visible !== false);
    const result: MenuItem[] = [];
    items.forEach(item => {
      if (!item.separator)
        result.push(item);
      else if (result.length > 0 && !result[result.length - 1].separator)
        result.push(item);
    });
    while (result.length > 0 && result[result.length - 1].separator)
      result.pop();
    return result;
  }

  tipText(item: MenuItem): string {
    return item.tooltip ?? '';
  }

  tipPos(item: MenuItem): TooltipPosition {
    return (item.tooltipPosition as TooltipPosition) || 'right';
  }
}
